import React from 'react';

import Button from '@material-ui/core/Button';

import { observer } from 'mobx-react'
import { useRouterStore } from 'mobx-state-router';
import { useRootStore } from 'contexts';

import FixedToolbar from 'components/FixedToolbar'
import MainLayoutVh from 'layouts/MainVh';

import TextSearch from 'components/search/TextSearch';
import PromotionsTableVirtualized from './components/PromotionsTableVirtualized'


const PromotionsScreen = observer(() => {

  const routerStore = useRouterStore();
  const rootStore = useRootStore();
  const {promotionsStore} = rootStore;

  const newObject = () => {
    routerStore.goTo('newPromotion');
  }
  
  const onSelectObject = id => {
    routerStore.goTo('promotion', { params: { id } });
  }

  const toolbar = <FixedToolbar>
      <TextSearch store={promotionsStore} searchTerm="search.text" placeholder='Search on name' />
      <TextSearch store={promotionsStore} searchTerm="trail" placeholder='Search on trail name' showSearchIcon={false} />
          
      <Button color="primary" variant="contained" onClick={() => newObject()}>Add a promotion</Button>
    </FixedToolbar>

  return <MainLayoutVh toolbar={toolbar} >
        <PromotionsTableVirtualized  store={promotionsStore} onSelectObject={onSelectObject} />
    </MainLayoutVh>;
});

export default PromotionsScreen;
